import { createElement, memo } from '@max/max';
import Sensor from '@max/mbc-sensor';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import ScrollView from '@hfe/max-scrollview';
import './index.scss';
import { BID_MAP, BID_TYPE } from '../../constant';
function CitySelector({ cities, currentCity, onCityChange, lxReport, cityTabBgColor, cityTabSelectedBgColor, cityTabTextColor, cityTabSelectedTextColor, paddingTop = 16 }) {
    const handleCityClick = (city) => {
        if (city.cityId !== currentCity.cityId) {
            lxReport(BID_MAP.CITY_MC, BID_TYPE.MC, {
                city_id: city.cityId
            });
            onCityChange(city);
        }
    };
    return <Sensor className="city-selector" style={{
        paddingTop: `${paddingTop}rpx`
    }} once onAppear={() => lxReport(BID_MAP.CITY_MV, BID_TYPE.MV, {
        city_id: cities.map(item => item.cityId).join(',')
    })}>
      <ScrollView horizontal showsHorizontalScrollIndicator={false} className="city-selector__scroll">
        <View className="city-selector__list">
          {cities.map((city, index) => {
        const isSelected = city.cityId === currentCity.cityId;
        const isFirst = index === 0;
        return <View key={city.cityId} className={`city-selector__item ${isSelected ? 'city-selector__item--selected' : ''} ${isFirst ? 'city-selector__item--first' : ''}`} style={isSelected ? cityTabSelectedBgColor ? {
            backgroundColor: cityTabSelectedBgColor
        } : {} : cityTabBgColor ? {
            backgroundColor: cityTabBgColor
        } : {}} onClick={() => handleCityClick(city)}>
                <View className="city-selector__item-content">
                  
                  <Text className={`city-selector__item-text ${isSelected ? 'city-selector__item-text--selected' : ''}`} style={isSelected ? cityTabSelectedTextColor ? {
            color: cityTabSelectedTextColor
        } : {} : cityTabTextColor ? {
            color: cityTabTextColor
        } : {}}>
                    {city.cityName}
                  </Text>
                  
                </View>
              </View>;
    })}
        </View>
      </ScrollView>
    </Sensor>;
}
export default memo(CitySelector);
